import { Box } from "@mui/material";
import { ReactNode } from "react";

type Props = {
  children: ReactNode;
};

export function Layout({ children }: Props) {
  return (
    <Box
      component="div"
      display="flex"
      width="100%"
      flexDirection={"column"}
      minHeight={"100dvh"}
      alignItems={"center"}
      justifyContent={"flex-start"}
    >
      {children}
    </Box>
  );
}
